<template>
  <div id="bottom">
  <el-row>
    <el-col :span="4" :offset="4"> <div class="card">
      <a href="https://github.com/hyperledger/fabric">
        <img src="img/bc.png"  style="width: 20%;height: 20%">
        <h3>Blockchain</h3>
      </a>
</div></el-col>
    <el-col :span="4" :offset="2"> <div class="card">

        <a href="https://github.com/docker">
          <img src="img/dc.png" style="width: 20%;height: 20%">
          <h3>Docker</h3>
        </a>
</div></el-col>
    <el-col :span="4" :offset="2"> <div class="card">
      <a href="https://go.dev">
        <img src="img/go.png"  style="width: 20%;height: 20%">
        <h3>Golang</h3>
      </a>

</div></el-col>
  </el-row>

  </div>

</template>

<script>
export default {
  name: "page2Bottom"
}
</script>

<style scoped>
.card{
  border-radius: 5px;
}

a{
  text-decoration: none;
  color: #606266;
}
.bottom{
  margin-top: 15%;
}
</style>